var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6667)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.25 11.25c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.25 14.25v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.25,20.25L15,18 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.25 20.25 2.25-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 6.75h10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 11.25h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 15.75h3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.5,20.25H2.25 c-0.828,0-1.5-0.672-1.5-1.5V2.25c0-0.828,0.672-1.5,1.5-1.5h10.629c0.398,0,0.779,0.158,1.06,0.439l2.872,2.872 c0.281,0.281,0.439,0.662,0.439,1.06V7.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropFile);
export default __webpack_public_path__ + "static/media/drop_file.a9226031.svg";
export { ForwardRef as ReactComponent };